import React, { FC, useState, useEffect } from 'react'
import i18n from 'i18next'
import { CdShow } from 'pages/mkt/components'
import mktController from 'controllers/mktController'
import { ddayjs, format } from '@dt/fe-utils'
import { storeMobx, decorationMobx } from '@mobxStore'
import { getPlatform } from '@utils'
import { sanitizeShareUrl } from '@common/utils/shareUrl'
import './index.scss'

interface IProps {
  info: any;
}

const GroupBuyStatus: FC<IProps> = (props: IProps) => {
  const { info } = props
  const { isWeixinMiniProgram } = getPlatform()
  const { mallGlobalDecorates: { groupBuyShare } } = decorationMobx
  const [isEnd, setIsEnd] = useState(false)
  const goShare = () => {
    const timeNum: number = ddayjs(info.memberOrder.groupBuy.addTime, 'brand').valueOf() + info.memberOrder.groupBuy.autoSuccessTime - new Date(ddayjs('brand').format('YYYY/MM/DD HH:mm:ss')).valueOf()
    let url: string = ''
    let imageUrl: string = ''
    let title: string = i18n.t('result.groupBuyTogether')
    if (info.ordersType === 'mall') {
      imageUrl = groupBuyShare?.image || format.toPic(info?.pics?.[0])?.url || ''
      title = groupBuyShare?.title || title
      url = `${location.origin}/mproduct/${info.detailList[0].productNo}${timeNum > 0 ? '/' + (info.memberOrder.groupBuy.groupBuyId || info.memberOrder.groupBuyId) : ''}?ct=brand&b=${info.brandId}`
    } else {
      url = `${location.origin}/iCard/cardOpen/open/${info.detailList[0].productExt ? JSON.parse(info.detailList[0].productExt).cardId : info.detailList[0].productNo}${timeNum > 0 ? '/' + (info.memberOrder.groupBuy.groupBuyId || info.memberOrder.groupBuyId) : ''}?ct=brand&b=${info.brandId}`
    }
    if (isWeixinMiniProgram) {
      const shareInfo = {
        title,
        path: sanitizeShareUrl(url),
        imageUrl,
      }
      const path: string = `/pages/launch/index?state=share&sharePageInfo=${encodeURIComponent(JSON.stringify({ mode: 'card', shareInfo: shareInfo }))}`
      window.wx?.miniProgram?.navigateTo({ url: path })
    } else if (url) {
      mktController.shareUrl(url)
    }
  }
  useEffect(() => {
    if (info) {
      const timeNum: number = ddayjs(info.memberOrder.groupBuy.addTime, 'brand').valueOf() + info.memberOrder.groupBuy.autoSuccessTime - new Date(ddayjs('brand').format('YYYY/MM/DD HH:mm:ss')).valueOf()
      let url: string = ''
      if (info.ordersType === 'mall') {
        url = `${location.origin}/mproduct/${info.detailList[0].productNo}${timeNum > 0 ? '/' + (info.memberOrder.groupBuy.groupBuyId || info.memberOrder.groupBuyId) : ''}?ct=brand&b=${info.brandId}`
      } else {
        url = `${location.origin}/iCard/cardOpen/open/${info.detailList[0].productExt ? JSON.parse(info.detailList[0].productExt).cardId : info.detailList[0].productNo}${timeNum > 0 ? '/' + (info.memberOrder.groupBuy.groupBuyId || info.memberOrder.groupBuyId) : ''}?ct=brand&b=${info.brandId}`
      }
      mktController.initShareData({
        url: url,
        title: i18n.t('result.groupBuyTogether'),
        des: i18n.t('result.groupBuyTogether'),
        img: storeMobx.brand.logo || ''
      })
    }
  }, [info])
  return (
    <div className='group-buy-status'>
      <div className='title'>{(info.memberOrder.groupBuy.status === 'success' || isEnd) ? i18n.t('result.groupBuySucc') : i18n.t('result.groupBuyNum', { num: info.memberOrder.groupBuy.groupBuyCnt - info.memberOrder.groupBuy.nowCnt })}</div>
      {
        (info.memberOrder.groupBuy.status !== 'success' && !isEnd) &&
          <>
            <div className='tip'>{i18n.t('result.groupCountdown')}</div>
            <div className='time'><CdShow time={info.memberOrder.groupBuy.addTime} showDay={false} addTime={info.memberOrder.groupBuy.autoSuccessTime} onEnd={() => { setIsEnd(true) }}></CdShow></div>
          </>
      }
      {
        (info.memberOrder.groupBuy.status === 'success' || isEnd) &&
          <>
            {info.ordersType === 'mall' ? <div className='mall-succ'>{i18n.t('result.mallSuccTip')}</div> : <div className='member-succ'>{i18n.t('result.memberSuccTip')}</div>}
          </>
      }
      <div className='btn' onClick={goShare}>{(info.memberOrder.groupBuy.status === 'success' || isEnd) ? i18n.t('mkt.activity.share') : i18n.t('result.groupBuyInvite')}<i className='iconfont icon-im_fenxiang_b'></i></div>
    </div>
  )
}
export default GroupBuyStatus
